import React, { useState, useEffect ,useContext} from 'react';
import { FaCheck, FaEdit, FaEye, FaPlus, FaPrint, FaTrash } from 'react-icons/fa';
import { getExpansive, deleteExpansive, approveVocher } from '../../api/Api'; // Import necessary API functions
import { Search } from 'lucide-react'; // If you're using lucide icons
import Loader from '../../Loader/Loader';
import Pagination from '../../Loader/Pagination'; // Ensure you have a Pagination component
import { MdOutlineModeEdit } from "react-icons/md";
import AllPAyment from '../Bill/AllPAyment';
import { useNavigate } from 'react-router-dom';
import { Filter } from "lucide-react";
import { AuthContext } from "../../utils/AuthContext";
import { generateAcademicYears } from "../../utils/academicYearUtils";
// import { useContext } from "react";
const Accounting = () => {
  const [expansives, setExpansives] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const userRole = localStorage.getItem("role");
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [approving, setApproving] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const navigate = useNavigate();
  const { academicYear, setAcademicYear } = useContext(AuthContext);

const academicYears = generateAcademicYears();
  const fetchBills = async () => {
    try {
      const response = await getExpansive();
      if (response.success) {
        setExpansives(response.data);
      } else {
        console.error("Failed to fetch bills:", response.message);
      }
    } catch (error) {
      console.error("Error fetching bills:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBills();
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredBills = Array.isArray(expansives) ? expansives.filter((expansive) => {
    const matchesSearch = (
      expansive.payeeName?.toLowerCase().includes(searchQuery) ||
      expansive.category?.toLowerCase().includes(searchQuery) ||
      expansive.payeePhoneNumber?.toLowerCase().includes(searchQuery)
    );
  
    const createdDate = new Date(expansive.approvalDate); // make sure your object has `createdAt` or similar
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
  
    const inRange =
      (!start || createdDate >= start) &&
      (!end || createdDate <= end);
  const academicYearMatch =
  !academicYear ||
  expansive.academicYear === academicYear;

return matchesSearch && inRange && academicYearMatch;
  }) : [];
  

  const totalPages = Math.ceil(filteredBills.length / itemsPerPage);
  const currentData = filteredBills.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handleApproved = async (id, amount) => {
    setApproving(true);
    try {
      const response = await approveVocher(id, amount); // Pass the amount to the API
      if (response.success) {
        fetchBills();
      } else {
        console.error("Failed to approve expansive:", response.message);
      }
    } catch (error) {
      console.error("Error approving expansive:", error);
    } finally {
      setApproving(false); 
    }
  };

  const openDeleteDialog = (id) => {
    setDeleteId(id);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
    setDeleteId(null);
  };

  const handleDelete = async () => {
    if (deleteId) {
      try {
        await deleteExpansive(deleteId);
        fetchBills();
      } catch (error) {
        console.error("Error deleting expansive:", error);
      } finally {
        closeDeleteDialog();
      }
    }
  };

  const totalExpansiveAmount = expansives.reduce((acc, expansive) => acc + (expansive.approvedAmount || 0), 0);
  
return (
  <div className="p-3 max-w-screen-xl mx-auto">

  
<div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4 mb-5">

  <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">

    {/* Left Side */}
    <div className="flex flex-wrap items-center gap-4">

      {/* Title */}
      <div>
        <h1 className="text-2xl font-bold text-[#16bab1]">
          Voucher
        </h1>

        <p className="text-sm text-gray-500">
          Manage all voucher records
        </p>
      </div>

      {/* Academic Year Filter */}
      <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-xl border border-gray-200 min-w-[180px]">

        <Filter size={16} className="text-[#16bab1]" />

        <div className="flex flex-col w-full">

          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            Academic Year
          </label>

          <select
            value={academicYear}
            onChange={(e) => setAcademicYear(e.target.value)}
            className="bg-transparent text-sm font-semibold text-gray-700 outline-none cursor-pointer"
          >
            <option value="">Overall View</option>

            {academicYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}

          </select>

        </div>

      </div>

      {/* Search */}
      <div className="relative w-full sm:w-[260px]">

        <Search
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          size={18}
        />

        <input
          type="search"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search voucher..."
          className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-xl outline-none focus:ring-2 focus:ring-[#16bab1]"
        />
      </div>

      {/* Date Filter */}
      <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">

        <div className="flex flex-col">
          <label className="text-[10px] font-bold uppercase text-gray-400">
            From
          </label>

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-transparent outline-none text-sm"
          />
        </div>

        <div className="w-px h-8 bg-gray-300"></div>

        <div className="flex flex-col">
          <label className="text-[10px] font-bold uppercase text-gray-400">
            To
          </label>

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-transparent outline-none text-sm"
          />
        </div>

      </div>

      {/* Total Amount */}
      <AllPAyment remainingVocher={totalExpansiveAmount} />

    </div>

    {/* Right Side */}
    <div>

      <button
        className="bg-[#16bab1] hover:bg-[#139a93] transition-all duration-200 text-white px-5 py-2.5 rounded-xl flex items-center gap-2 shadow-sm font-semibold whitespace-nowrap"
        onClick={() => navigate('/admin/expan')}
      >
        <FaPlus />
        Add Voucher
      </button>

    </div>

  </div>

</div>

    {loading ? (
      <Loader />
    ) : (
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded text-sm">

      
          <thead className="bg-[#16bab1] text-white">
            <tr>
              <th className="py-1 px-2 border">S.No</th>
              <th className="py-1 px-2 border">Payee Name</th>
              <th className="py-1 px-2 border">Category</th>
              <th className="py-1 px-2 border">Contact</th>

              <th className="py-1 px-2 border">Mode of Payment</th>

              <th className="py-1 px-2 border">Amount</th>
              <th className="py-1 px-2 border">Approve Status</th>
              <th className="py-1 px-2 border">VR.No</th>
              <th className="py-1 px-2 border">Action</th>
            </tr>
          </thead>

        
          <tbody>
            {currentData.map((expansive, index) => (
              <tr key={expansive._id} className="hover:bg-gray-50">

                <td className="py-1 px-2 border">
                  {(currentPage - 1) * itemsPerPage + index + 1}
                </td>

                <td className="py-1 px-2 border">{expansive.payeeName}</td>
                <td className="py-1 px-2 border">{expansive.category}</td>
                <td className="py-1 px-2 border">{expansive.payeePhoneNumber}</td>

                <td className="py-1 px-2 border">
                  {expansive.paymentMode || "-"}
                </td>

                <td className="py-1 px-2 border">₹{expansive.amount}</td>

                <td className="py-1 px-2 border">
                  {expansive.approved ? (
                    <span className="text-green-500">Approved</span>
                  ) : userRole === 'admin' ? (
                    <button
                      className="text-blue-500 text-xs"
                      onClick={() => handleApproved(expansive._id, expansive.amount)}
                      disabled={approving}
                    >
                      {approving ? '...' : 'Approve'}
                    </button>
                  ) : (
                    <span className="text-red-500">Pending</span>
                  )}
                </td>

                <td className="py-1 px-2 border">{expansive.invoiceNo}</td>

            
                <td className="py-1 px-2 border flex justify-center gap-2">

        
                  <FaEye
                    className="text-blue-600 cursor-pointer"
                    onClick={() => navigate(`/admin/ViewExpan/${expansive._id}`)}
                  />

           
                   <FaPrint
                    className="text-purple-600 cursor-pointer"
                    onClick={() => navigate(`/admin/ViewExpan/${expansive._id}?print=true`)}
                  />

               
                  {userRole === 'admin' && (
                    <>
                      <MdOutlineModeEdit
                        className="text-yellow-600 cursor-pointer"
                        onClick={() => navigate(`/admin/expan/${expansive._id}`)}
                      />

                      <FaTrash
                        className="text-red-600 cursor-pointer"
                        onClick={() => openDeleteDialog(expansive._id)}
                      />
                    </>
                  )}

                </td>

              </tr>
            ))}

            {currentData.length === 0 && (
              <tr>
                <td colSpan="9" className="text-center py-3 text-[#16bab1]">
                  No payments found.
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
    )}

  </div>
);
};

export default Accounting;